/**
 * Normalizes feature names by replacing IDs with placeholders
 * Example: /rides/cmk073udk000004jvlesjxzrb -> /rides/:id
 */

export const normalizeFeatureName = (pathname: string): string => {
  if (!pathname) return 'unknown';

  // Replace common ID patterns with placeholders
  // Matches cuid-like IDs (25 chars, alphanumeric) and UUIDs
  const idPattern = /\/[a-z0-9]{20,}(?=\/|$)/gi;
  
  let normalized = pathname.replace(idPattern, (match) => {
    // Check if it looks like an ID (long alphanumeric string)
    if (match.length > 15) {
      return '/:id';
    }
    return match;
  });

  // Handle specific route patterns
  normalized = normalized
    .replace(/\/rides\/[^/]+/g, '/rides/:id')
    .replace(/\/feed\/news\/[^/]+/g, '/feed/news/:id')
    .replace(/\/messages\/[^/]+/g, '/messages/:id')
    .replace(/\/profile\/[^/]+/g, '/profile/:id')
    .replace(/\/friends\/[^/]+/g, '/friends/:id')
    .replace(/\/stores\/[^/]+/g, '/stores/:id')
    .replace(/\/users\/[^/]+/g, '/users/:id');

  return normalized;
};

